<script>
import AppNavbar from '@/components/AppNavbar.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
    name: 'App',
    components: { AppNavbar, AppFooter },
}
</script>

<template>
    <div class="ps-app d-flex flex-column min-vh-100">
        <b-link href="#main" class="sr-only sr-only-focusable ps-skip">Skip to content</b-link>
        <app-navbar />
        <main id="main" class="flex-grow-1">
            <router-view />
        </main>
        <app-footer />
    </div>
</template>

<style lang="scss">
.ps-app {
    overflow-x: hidden;
}

.ps-skip:focus {
    position: absolute;
    top: 0.75rem;
    left: 0.75rem;
    z-index: 1050;
    padding: 0.5rem 1rem;
    border-radius: 999px;
    background: var(--ps-frost);
    color: var(--ps-ink);
}
</style>
